import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import WidgetPanel from  '@/components/page/widgetsPanel/WidgetPanelScreen';


class WidgetsPortal extends Component {
  constructor(props:any){
    super(props);  
    (window as any).reMountWidgetPanelPortal = this;
  }
  
  reBind(){
    this.forceUpdate();
  }

  render() {
    const targetContainers = document.querySelectorAll('#react-widget-panel-container');

    const isDCTEnabled:HTMLInputElement = document.querySelector('#DynamicContentTranslationEnabled') as HTMLInputElement;

    // If no containers found, return null
    if (targetContainers.length === 0) {
      return null;
    }

    // There are many different times this portal will appear on a page
    const widgetPanels = Array.from(targetContainers).map((container) => {
      const isPageView = container.getAttribute('pageView');

      return ReactDOM.createPortal(
        <WidgetPanel isPageView={isPageView === 'isPageView'} isDCTEnabled={isDCTEnabled?.value === 'True'}/>,
        container
      );
    });

    return widgetPanels;
  }
}
export default WidgetsPortal;